import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const selectSettingsUsersState = (state: RootState) => state.settingsUsers;

export const selectSettingsUsersRows = createSelector(
  [selectSettingsUsersState],
  (state) => state.rows,
);

export const selectSettingsUsersLoading = createSelector(
  [selectSettingsUsersState],
  (state) => state.loading,
);

export const selectSettingsUsersError = createSelector(
  [selectSettingsUsersState],
  (state) => state.error,
);

export const selectSettingsUsersTotal = createSelector(
  [selectSettingsUsersState],
  (state) => state.totalUsers,
);

export const selectSettingsUsersFromIndex = createSelector(
  [selectSettingsUsersState],
  (state) => state.fromIndex,
);

export const selectSettingsUsersSortOrder = createSelector(
  [selectSettingsUsersState],
  (state) => state.sortingOrder,
);

export const selectSettingsUsersSubmitting = createSelector(
  [selectSettingsUsersState],
  (state) => state.submitting,
);

export const selectSettingsUsersSubmitError = createSelector(
  [selectSettingsUsersState],
  (state) => state.submitError,
);

export const selectSettingsUsersDeleteSubmitting = createSelector(
  [selectSettingsUsersState],
  (state) => state.deleteSubmitting,
);

export const selectSettingsUsersDeleteError = createSelector(
  [selectSettingsUsersState],
  (state) => state.deleteError,
);

export const selectSettingsUsersListFilterStatus = createSelector(
  [selectSettingsUsersState],
  (state) => state.listFilterStatus,
);

export const selectSettingsUsersListFilterRoleName = createSelector(
  [selectSettingsUsersState],
  (state) => state.listFilterRoleName,
);
